interface AuditProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function AuditProgress({ currentStep, totalSteps }: AuditProgressProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-light-gray/80">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm text-cyan font-semibold">{Math.round(progress)}%</span>
      </div>
      <div className="w-full bg-background rounded-full h-2 overflow-hidden">
        <div
          className="bg-gradient-to-r from-cyan to-bronze h-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}